var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "BjDivider",
        [
          _vm._v(
            _vm._s(
              _vm.$t(
                "BusinessStockDistributionQtyAddWarehouse.basicInformation"
              )
            ) + " "
          ),
          _c(
            "template",
            { slot: "right" },
            [
              _c("el-button", { on: { click: _vm.tryCancel } }, [
                _vm._v(_vm._s(_vm.$t("cancelText"))),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleConfirm },
                },
                [_vm._v(_vm._s(_vm.$t("saveText")))]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            "label-position": "top",
            model: _vm.form,
            rules: _vm.rules,
            "label-width": "120px",
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockDistributionQtyAddWarehouse.supportWarehouseType"
                        ),
                        prop: "supportWarehouseType",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          disabled: "",
                          value: _vm.$t(
                            "BusinessStockDistributionQtyAddWarehouse.realPosition"
                          ),
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockDistributionQtyAddWarehouse.supportWarehouseId"
                        ),
                        prop: "supportWarehouseId",
                      },
                    },
                    [
                      _c("BjSelectWarehouse", {
                        attrs: { "type-code": ["real"] },
                        on: { change: _vm.onChangeSupportWarehouseId },
                        model: {
                          value: _vm.form.supportWarehouseId,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "supportWarehouseId", $$v)
                          },
                          expression: "form.supportWarehouseId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockDistributionQtyAddWarehouse.supportWarehouseCode"
                        ),
                        prop: "supportWarehouseCode",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          disabled: "",
                          value: _vm.form.supportWarehouseCode,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "BjDivider",
        [
          _vm._v(
            _vm._s(
              _vm.$t(
                "BusinessStockDistributionQtyAddWarehouse.commodityDetails"
              )
            ) + " "
          ),
          _c(
            "template",
            { slot: "button" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.dialogListGoodsShow()
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "BusinessStockDistributionQtyAddWarehouse.addGoods"
                      )
                    )
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "el-table",
        {
          ref: "multipleTable",
          attrs: {
            data: _vm.tableDataSku,
            stripe: "",
            border: "",
            "header-cell-style": _vm.$rowStyle.DEFAULT,
            "row-key": "BJ_EBC_ID",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              type: "index",
              width: "60",
              align: "center",
              label: _vm.$t("table.countText"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "categoryName",
              align: "center",
              label: _vm.$t(
                "BusinessStockDistributionQtyAddWarehouse.table.categoryName"
              ),
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "skuCode",
              align: "center",
              label: _vm.$t(
                "BusinessStockDistributionQtyAddWarehouse.table.skuCode"
              ),
            },
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "right",
              label: _vm.$t("table.operationText"),
              width: "100",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        staticClass: "delete-btn",
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.onDeleteSku(scope.row)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("delText")))]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "BjDivider",
        [
          _vm._v(
            _vm._s(
              _vm.$t(
                "BusinessStockDistributionQtyAddWarehouse.receivingWarehouse"
              )
            ) + " "
          ),
          _c(
            "template",
            { slot: "button" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.dialogListWarehouseShow("qty-virtual")
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "BusinessStockDistributionQtyAddWarehouse.qtyVirtual"
                      )
                    )
                  ),
                ]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.dialogListWarehouseShow("interline-virtual")
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "BusinessStockDistributionQtyAddWarehouse.interlineVirtual"
                      )
                    )
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "el-table",
        {
          ref: "multipleTable",
          attrs: {
            data: _vm.tableDataWarehouse,
            stripe: "",
            border: "",
            "header-cell-style": _vm.$rowStyle.DEFAULT,
            "row-key": "BJ_EBC_ID",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              type: "index",
              width: "60",
              align: "center",
              label: _vm.$t("table.countText"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "receiveTypeCode",
              align: "center",
              label: _vm.$t(
                "BusinessStockDistributionQtyAddWarehouse.table.receiveTypeCode"
              ),
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$store.state.values.STOCK_WAREHOUSE_TYPE.bjGet(
                            scope.row.receiveTypeCode
                          )
                        ) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "receiveCode",
              align: "center",
              label: _vm.$t(
                "BusinessStockDistributionQtyAddWarehouse.table.receiveCode"
              ),
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "receiveName",
              align: "center",
              label: _vm.$t(
                "BusinessStockDistributionQtyAddWarehouse.table.receiveName"
              ),
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "distributionQty",
              align: "center",
              label: _vm.$t(
                "BusinessStockDistributionQtyAddWarehouse.table.distributionQty"
              ),
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _c("BjInput", {
                      attrs: { maxlength: _vm.MAX_LENGTH.DEFAULT },
                      model: {
                        value: props.row.distributionQty,
                        callback: function ($$v) {
                          _vm.$set(props.row, "distributionQty", $$v)
                        },
                        expression: "props.row.distributionQty",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "right",
              label: _vm.$t("table.operationText"),
              width: "100",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        staticClass: "delete-btn",
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.onDeleteWarehouse(
                              scope.row,
                              scope.$index
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("delText")))]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("BjDialogList", {
        ref: "dialogListWarehouse",
        attrs: { config: _vm.dialogListWarehouseConfig, multiple: "" },
        on: { confirm: _vm.onConfirmDialogList },
      }),
      _c("BjDialogList", {
        ref: "dialogListGoods",
        attrs: { config: _vm.dialogListGoodsConfig },
        on: { confirm: _vm.onConfirmDialogListGoods },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }